/**
@module ember
*/

function ActionManager() {}

/**
  Global action id hash.

  @private
  @property registeredActions
  @type Object
*/
ActionManager.registeredActions = {};

export { ActionManager as default };
